module.exports = __webpack_public_path__ + "static/media/viasat-sport-premium.cbd46f60.png";